export const LOCALES = ['en', 'ru'] as const;

export type Language = typeof LOCALES[number];
